






























































import { Component, Vue } from "vue-property-decorator"
import CandidateForgotPassword from "./ForgotPassword/CandidateForgotPassword.vue"

@Component({
  components: {
    CandidateForgotPassword,
  },
})
export default class CandidateGetStarted extends Vue {
  showMore = false

  toggleShowMore() {
    this.showMore = !this.showMore
  }
}
